import { Col, Row } from "antd";
import React from "react";
import ImageRowContainer from "../../../components/ImageRowContainer";
import { setColSize1, setColSize2 } from "../cards-utils";

const CardsList = ({ cardsList, onClick, resizeWidth }) => {
  const col1 = setColSize1(resizeWidth);
  const col2 = setColSize2(resizeWidth);

  const acounts = cardsList.map((account, index) => {
    const { key, icon, disabled } = account;

    return (
      <li
        className={`saved-card-list-item saved-card-list-item-${index} ${
          disabled ? "disable-list-item" : ""
        }`}
        key={key}
      >
        <Row>
          <Col md={13} sm={13} xs={20}>
            <ImageRowContainer
              props={account}
              className="saved-cards-content"
              titleClass="capitalize font-14-regular-400-lh-22 gray-color"
              subTitleClass="saved-card-sub-title font-18-regular-500-lh-22 primary-color"
              colsize1={col1}
              colsize2={col2}
            />
          </Col>
          <Col md={11} sm={11} xs={4}>
            <Row className="saved-cards-content-card-icon-row">
              <Col md={12} sm={12} xs={12}></Col>
              <Col md={12} sm={12} xs={12}>
                <div
                  className="account-delete-icon pointer"
                  onClick={() => onClick(key)}
                >
                  <img src={icon} alt={icon} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </li>
    );
  });

  return <ul className="saved-cards saved-cards-list">{acounts}</ul>;
};

export default CardsList;
